import React, { Component } from "react";
import withServices from "../hocs/withServices";
import {
  TextField,
  Grid,
  Button,
  withStyles,
  Paper,
  MenuItem,
  Typography,
} from "@material-ui/core";
import FileUpload from "./utils/FileUpload";
import Constants from "../common/constants";
import Loader from "./utils/Loader";

const styles = (theme) => ({
  root: {
    // '& .MuiFormControl-root': {
    //   width: '80%',
    //   margin: theme.spacing(1)
    // }
  },
  pageContent: {
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(0),
      padding: theme.spacing(1),
    },
  },
  txtField: {
    [theme.breakpoints.down("xs")]: {
      paddingTop: "25px",
    },
  },
});

class IdentityDocs extends Component {
  state = {
    loading: true,
    // Проверка был ли пользователь подтвержден техсекретарем
    isApproved: false,

    documents: [],
    institutions: [],
    //Выбор органа выдачи
    selectedIssuingAuthority: "",
    //Выбор документа
    selectedIdentityDocumentType: "",
    //Номер документа
    selectedIdentityDocumentNumber: "",
    //Дата выдачи документа
    selectedIdentityDocumentIssueDate: "",
    //Дата оконачания документа
    selectedIdentityDocumentValidityPeriod: "",
    //Поле для заполнения при выборе другого документа
    selectedOtherDocumentType: "",
    //Файл Лицевая сторона  уд личности
    identityFront: "",
    //Файл Обратная сторона уд личности
    identityBack: "",
    //Файл Справка 086 формы
    form086: "",
    documentConfirmingAvailabilityOfInternalGrantScan: "",
    pripisnoiBiletScan: "",

    // Path (путь) загружаемых документов (identityFront, identityBack, form086 и documentConfirmingAvailabilityOfInternalGrant)
    identityFrontPath: "",
    identityBackPath: "",
    form086Path: "",
    documentConfirmingAvailabilityOfInternalGrantScanPath: "",
    pripisnoiBiletPath: "",
  };

  fetchData() {
    const { documentPage, secretary, dictionary, auth } = this.props.services;

    dictionary.getIssuingAuthority().then((response) => {
      if (response?.data) {
        this.setState({
          institutions: response.data,
        });
      }
    });

    dictionary.getDocumentTypes().then((response) => {
      if (response?.data) {
        this.setState({
          documents: response.data,
        });
      }
    });

    (async () => {
      const isApproved = (
        await secretary.checkConfirm(auth.getCurrentUser().id)
      ).data;

      this.setState(
        {
          isApproved,
        },
        () => {
          documentPage.getDocuments().then((response) => {
            if (response?.data) {
              const { data } = response;
              console.log(data);
              this.setState(
                {
                  selectedIssuingAuthority: data.documentIssuingAuthority?.id,
                  selectedIdentityDocumentType: data.identityDocumentType?.id,
                  selectedIdentityDocumentNumber: data.identityDocumentNumber,
                  selectedIdentityDocumentIssueDate:
                    data.identityDocumentIssueDate,
                  selectedIdentityDocumentValidityPeriod:
                    data.identityDocumentValidityPeriod,
                  selectedOtherDocumentType: data.otherDocumentType,
                  identityFront: data.identityDocumentScanFront?.id,
                  identityBack: data.identityDocumentScanBack?.id,
                  form086: data.form086?.id,
                  documentConfirmingAvailabilityOfInternalGrantScan:
                    data.documentConfirmingAvailabilityOfInternalGrantScan?.id,
                  pripisnoiBiletScan: data.pripisnoiBilet?.id,

                  // Path (путь) загружаемых документов (identityFront, identityBack и form086, documentConfirmingAvailabilityOfInternalGrant)
                  identityFrontPath: data.identityDocumentScanFront?.path,
                  identityBackPath: data.identityDocumentScanBack?.path,
                  form086Path: data.form086?.path,
                  documentConfirmingAvailabilityOfInternalGrantScanPath:
                    data.documentConfirmingAvailabilityOfInternalGrantScan
                      ?.path,
                  pripisnoiBiletPath: data.pripisnoiBilet?.path,
                },
                () => {
                  this.setState({
                    loading: false,
                  });
                }
              );
            } else {
              this.setState({
                loading: false,
              });
            }
          });
        }
      );
    })();
  }

  componentDidMount() {
    this.fetchData();
  }

  onSubmit = () => {
    const { state } = this;

    const data = {
      documentIssuingAuthorityId: state.selectedIssuingAuthority || null,
      identityDocumentTypeId: state.selectedIdentityDocumentType || null,
      identityDocumentNumber: state.selectedIdentityDocumentNumber || null,
      identityDocumentIssueDate:
        state.selectedIdentityDocumentIssueDate || null,
      identityDocumentValidityPeriod:
        state.selectedIdentityDocumentValidityPeriod || null,
      otherDocumentType: state.selectedOtherDocumentType || null,
      identityDocumentScanFrontId: state.identityFront || null,
      identityDocumentScanBackId: state.identityBack || null,
      form086Id: state.form086 || null,
      documentConfirmingAvailabilityOfInternalGrantScanId:
        state.documentConfirmingAvailabilityOfInternalGrantScan || null,
      pripisnoiId: state.pripisnoiBiletScan || null,
    };

    this.props.services.documentPage
      .saveDocuments(data)
      .then(() => {
        alert("Ваши данные успешно сохранены");
        this.fetchData();
      })
      .catch(() => alert("В форме присутствуют некорректно заполненные поля"));
  };

  render() {
    const { classes } = this.props;

    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <Paper className={classes.pageContent}>
          <form className={classes.root}>
            <Typography variant="h5">Документы</Typography>
            <Grid container justify="center" spacing={3}>
              {this.state.isApproved && (
                <Grid item xs={12}>
                  <Typography align="center" variant="h6">
                    Вы не можете ничего менять, так как ваши данные уже
                    подтверждены
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Документ, удостоверяющий личность"
                  className={classes.txtField}
                  select
                  value={this.state.selectedIdentityDocumentType}
                  onChange={(event) =>
                    this.setState({
                      selectedIdentityDocumentType: event.target.value,
                    })
                  }
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {this.state.documents.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {this.state.selectedIdentityDocumentType &&
                this.state.selectedIdentityDocumentType === 5 && (
                  <>
                    <Grid item xs={12} md={8} lg={10}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        label="Тип документа"
                        value={this.state.selectedOtherDocumentType}
                        onChange={(event) =>
                          this.setState({
                            selectedOtherDocumentType: event.target.value,
                          })
                        }
                      />
                    </Grid>
                  </>
                )}
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={this.state.selectedIdentityDocumentNumber}
                  label="Номер документа"
                  onChange={(event) =>
                    this.setState({
                      selectedIdentityDocumentNumber: event.target.value,
                    })
                  }
                ></TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="date"
                  value={this.state.selectedIdentityDocumentIssueDate}
                  helperText="Дата выдачи документа, удостоверяющий личность"
                  onChange={(event) =>
                    this.setState({
                      selectedIdentityDocumentIssueDate: event.target.value,
                    })
                  }
                ></TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  type="date"
                  value={this.state.selectedIdentityDocumentValidityPeriod}
                  helperText="Срок действия документа, удостоверяющий личность"
                  onChange={(event) =>
                    this.setState({
                      selectedIdentityDocumentValidityPeriod:
                        event.target.value,
                    })
                  }
                ></TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Орган выдачи документа, удостоверяющий личность"
                  select
                  className={classes.txtField}
                  value={this.state.selectedIssuingAuthority}
                  onChange={(event) =>
                    this.setState({
                      selectedIssuingAuthority: event.target.value,
                    })
                  }
                >
                  <MenuItem value="none" disabled>
                    Выберите один из вариантов
                  </MenuItem>
                  {this.state.institutions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Скан документа, удостоверяющий личность (лицевая сторона)"
                  fileType={Constants.FILE_TYPES.identityFront}
                  file={this.state.identityFront}
                  filePath={this.state.identityFrontPath}
                  handleSetFileId={(fileId) =>
                    this.setState({ identityFront: fileId })
                  }
                  handleDelete={() => {
                    this.fetchData();
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Скан документа, удостоверяющий личность (обратная сторона)"
                  fileType={Constants.FILE_TYPES.identityBack}
                  file={this.state.identityBack}
                  filePath={this.state.identityBackPath}
                  handleSetFileId={(fileId) =>
                    this.setState({ identityBack: fileId })
                  }
                  handleDelete={() => {
                    this.fetchData();
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Скан справки формы 075 (+ флюро)"
                  fileType={Constants.FILE_TYPES.form086}
                  file={this.state.form086}
                  filePath={this.state.form086Path}
                  handleSetFileId={(fileId) =>
                    this.setState({ form086: fileId })
                  }
                  handleDelete={() => {
                    this.fetchData();
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Скан документа, подтверждающего наличие внутреннего гранта (победители олимпиад AITU iCode \ AITU Open \ Международная Жаутыковская Олимпиада) (при наличии)"
                  fileType={
                    Constants.FILE_TYPES
                      .documentConfirmingAvailabilityOfInternalGrant
                  }
                  file={
                    this.state.documentConfirmingAvailabilityOfInternalGrantScan
                  }
                  filePath={
                    this.state
                      .documentConfirmingAvailabilityOfInternalGrantScanPath
                  }
                  handleSetFileId={(fileId) =>
                    this.setState({
                      documentConfirmingAvailabilityOfInternalGrantScan: fileId,
                    })
                  }
                  handleDelete={() => {
                    this.fetchData();
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <FileUpload
                  helperText="Cкан документа Приписного военного билета (только мужской пол)"
                  fileType={Constants.FILE_TYPES.pripisnoiBilet}
                  file={this.state.pripisnoiBiletScan}
                  filePath={this.state.pripisnoiBiletPath}
                  handleSetFileId={(fileId) =>
                    this.setState({ pripisnoiBiletScan: fileId })
                  }
                  handleDelete={() => {
                    this.fetchData();
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <Grid container justify="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.onSubmit}
                    disabled={this.state.isApproved}
                  >
                    Сохранить
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </>
    );
  }
}
export default withStyles(styles)(withServices()(IdentityDocs));
